// extracted by mini-css-extract-plugin
module.exports = {"sliders":"capacity_sliders__dMsUx","row":"capacity_row__YDirS","title":"capacity_title__0dxoI","phAnimation":"capacity_phAnimation__Euzhb"};